export const IDV2_CONTAINER_ID = 'idv2-container';
export const LEGACY_IDV_CONTAINER_ID = 'layout-container';
export const NAVIGATION_HEADER_PORTAL_ID = 'navigation-header-portal';
export const IDV_BODY_CONTENT_CONTAINER_ID = 'idv-body-content-container';
export const FOOTPRINT_FOOTER_ID = 'footprint-footer';
// Grows a small button's tap area toward 48px on touch screens without moving the layout.
export const TOUCH_TARGET_CLASS =
  'relative pointer-coarse:after:absolute pointer-coarse:after:-inset-x-2 pointer-coarse:after:-inset-y-3';
